module.exports = __webpack_public_path__ + "static/media/msgicon3.e7b33573.webp";